module.exports = __webpack_public_path__ + "img/two.42a2e483.png";